import axios from 'axios';
import { config } from '@uhg-abyss/web/tools/config';
import { AUTH_CONFIG } from '@src/config/config';

const REDIRECT_URI = config('SSO_REDIRECT_URI');

export interface TokenPayload {
  code: string;
  redirect_uri?: string;
  code_verifier: string;
}

export const getAuthCode = async (payload: TokenPayload) => {
  try {
    const tokenUrl = AUTH_CONFIG.tokenUrl;
    if (!tokenUrl) {
      throw new Error('SSO Auth Token URL is not defined');
    }

    const redirectUri = payload.redirect_uri ?? REDIRECT_URI ?? '';
    const params = new URLSearchParams({
      grant_type: 'authorization_code',
      code: payload.code,
      redirect_uri: redirectUri,
      client_id: AUTH_CONFIG.clientId,
      code_verifier: payload.code_verifier,
    }).toString();

    const response = await axios.post(tokenUrl, params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

    return response.data;
  } catch (error: any) {
    const detail = error?.response?.data;
    console.error('Error fetching auth code', detail ?? error);
    throw error;
  }
};
